import { useSelector } from 'react-redux';
import { selectAppInstanceConfigsStatus } from 'store/app-instance-configs/selectors';
import { ACTION_STATUSES } from 'shared/consts';
import { selectTransactionsLoading } from 'store/transactions/selectors';
import { useFilteringEnabled } from 'hooks/use-filtering-enabled.hook';
import { useGetCurrentLocationResourcesTypesQuery } from 'store/resources/hooks';

export const useLoadingHandler = (): boolean => {
  const isFilteringEnabled = useFilteringEnabled();
  const isAppInstanceConfigsLoading = useSelector(selectAppInstanceConfigsStatus) === ACTION_STATUSES.PENDING;
  const { isLoading: isResourceTypesLoading } = useGetCurrentLocationResourcesTypesQuery({ skip: true });
  const isTransactionsLoading = useSelector(selectTransactionsLoading);

  return isFilteringEnabled
    ? isAppInstanceConfigsLoading || isResourceTypesLoading || isTransactionsLoading
    : isAppInstanceConfigsLoading || isTransactionsLoading;
};
